module.exports = __webpack_public_path__ + "img/64.66ea75cb.jpg";